import request from '@/utils/request';

export function getInstituteList(query) {
  return request({
    url: '/institutes',
    method: 'get',
    params: query,
  });
}

export function getInstitute(id) {
  return request({
    url: `/institutes/${id}`,
    method: 'get',
  });
}

export function instituteCount() {
  return request({
    url: '/institutes/count',
    method: 'get',
  });
}
